module.exports = __webpack_public_path__ + "img/horizontal_3_2_7016.d4468e0c.png";